import {
	OperationType,
	UploadStatus,
} from '../../../shared/enums/batch-actions.enum';

import { ItemDescription } from './item-description.model';

export interface BatchAction {
	id: string;
	createdAt: string;
	fileKey: string;
	operationType: OperationType;
	organizationName: string;
	status: UploadStatus;
	userName: string;
}

export interface BatchActionsResponse {
	uploads: BatchAction[];
}

export interface BatchActionFileResponse {
	url: string;
}

export interface BatchActionDocument {
	id: string;
	createdAt: Date;
	key_aws: string;
	name: string;
	size: number;
	type: string;
	upload_id: string;
	url?: string;
	userName: string;
}

export interface BatchActionInfo {
	id: string;
	description: {
		data: ItemDescription[];
		message: string;
	};
	files: BatchActionDocument[];
	organizationName: string;
	status: UploadStatus;
	updatedAt: string;
	userName: string;
}

export const UPLOAD_STATUS_LABEL = [
	{ label: 'Sucesso', status: UploadStatus.SUCCESS },
	{ label: 'Processando', status: UploadStatus.IN_PROCESS },
	{ label: 'Falha', status: UploadStatus.FAILURE },
];

export interface DownloadFilesRequest {
	fileIds: string[];
}

export interface DownloadFilesResponse {
	files: {
		name: string;
		url: string;
	}[];
}
